<ng-container *ngFor="let addon of addons; index as idx">
  <div class="addon-row" *ngIf="idx + 1 <= pageSize" (click)="onRowClicked(addon)">
    <div class="product-details xmat-elevation-z2">
      <div>
        <ng-container *ngIf="addon.icon; else noicon">
          <img id="product-icon" [src]="addon.icon" />
        </ng-container>
        <ng-template #noicon>
          <mat-icon class="product-default-icon">add_circle</mat-icon>
        </ng-template>
      </div>
      <div class="description-and-tagline">
        <div>
          <span class="addon-title">{{ addon.title }}</span>
        </div>
        <div>
          <span class="addon-tagline">{{ addon.tagline }}</span>
        </div>
      </div>
      <div class="pricing">
        <billing-ui-price-display
          [appPrice]="getAppPriceForIndex(idx)"
          [currencyCode]="currency"
          [align]="'end'"
        ></billing-ui-price-display>
      </div>
    </div>
  </div>
</ng-container>

<div class="load-more" *ngIf="pageSize < addons.length" (click)="onLoadMoreClicked()">
  <mat-icon>add</mat-icon>
  <span>Load more</span>
</div>
